import {GameModuleResponse} from './GameModuleResponse';
import {IRouletteWin} from '../Types/IRouletteWin';
import {RouletteSpinBet} from '../Types/RouletteSpinBet';
import {IRouletteStatistics} from '../Types/IRouletteStatistics';
import {ITableGamePlayer} from '../Types/ITableGamePlayer';

/**
 * @class GameModuleBlackJackResponse - game module response type of module "blackjack", eq: ResponseBase->modules["base"].
 */
export class GameModuleBlackJackResponse extends GameModuleResponse {

    /**
     * An array containing objects representing table game players.
     */
    players: Array<ITableGamePlayer>;

    /**
     * @property initData - Slot initialization data. Sent only for Initialize request.
     */
    initData: {

        /**
         * @property betSettings - Bet configuration.
         */
        betSettings: {

            /**
             * @property chips - List of chips displayed on frontend.
             */
            chips?: Array<number>;
        };

        /**
         * @property customData - Custom slot initialization data specific to game module.
         * Optional.
         */
        customData?: any;
    };

    protected internalValidate(errors: Array<string>): void {
        // TODO(lepko) add check for required properties...
    }

    public moduleName(): string {
        return 'base';
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/GameModuleBlackJackResponse.ts
 **/